import { UpdateControlMetadata } from '../validators/helpers';

export function InternalControl(target: any, propertyKey: string) {
  UpdateControlMetadata(target, propertyKey, { internal: true });
}
